import React, { useState, useContext, useEffect } from "react";
import MultiSelect from "./index";

import "./MultiPulldown.scss";
import { ShopContext } from "app/contexts/ShopContext";
import { AppSelectShopContext } from "app/contexts/AppSelectShopContext";

const MultiPulldown = ({ items, label, handleChange }) => {
  const { shops, setShops } = useContext(ShopContext)

  const { appSelectShopId, setAppSelectShopId } = useContext(AppSelectShopContext)
  const { appSelectShopName, setAppSelectShopName } = useContext(AppSelectShopContext)
  const { appSelectBrandId, setAppSelectBrandId } = useContext(AppSelectShopContext)
  const { appSelectBrandName, setAppSelectBrandName } = useContext(AppSelectShopContext)

  useEffect(() => {
    (async () => {
      console.log('shops2::' + JSON.stringify(shops));

      var cat = localStorage.getItem("ssvShops");
      console.log('localstorage:' + cat)
      if (cat != null) {
        setShops(JSON.parse(cat));
      } else {
        //console.log('店舗選択されてない')
      }

    })()
  }, [ShopContext]);



  // const [props, setProps] = useState([]);
  //const getOptionLabel = option => `${option.label}`;
  const getOptionLabel = option => `${option.name}`;
  const handleToggleOption = props => {
    //if (shops) {
    //  setShops(shops)
    //} else {
    //  setShops(props);
    //}
    setShops(props);

    //setProps(props);
    if (handleChange) {
      handleChange(props); //console.log('hoge');
    }

    //console.log('hoge handleToggleOption')
    //console.log('★::' + JSON.stringify(props));
    localStorage.setItem('ssvShops', JSON.stringify(props));
    //console.log('get::' + localStorage.getItem('ssvShops'));

    // localStorageからデータを取得
    const storedData = localStorage.getItem('ssvShops');

    // JSONデータとしてパース
    const parsedData = JSON.parse(storedData);

    // nameとbrandNameを抽出
    if (parsedData && parsedData.length > 0) {
      const firstShop = parsedData[0]; // 最初の要素を取得
      const id = firstShop.id;
      const name = firstShop.name;
      const brandId = firstShop.brandId;
      const brandName = firstShop.brandName;

      //console.log('name:', name);
      //console.log('brandName:', brandName);

      setAppSelectShopId(id);
      setAppSelectShopName(name);
      setAppSelectBrandId(brandId);
      setAppSelectBrandName(brandName);

    } else {
      console.log('データが見つかりません。');
    }

    //console.log('shops::' + JSON.stringify(shops));
  }
  const handleClearOptions = () => {
    //console.log('hoge handleClearOptions')
    setShops([])
    //setProps([]);
    if (handleChange) handleChange([])
  };
  const handleSelectAll = isSelected => {
    //console.log('hoge handleSelectAll')
    if (isSelected) {
      setShops(items);
      //setProps(items);
      if (handleChange) handleChange(items)
    } else {
      handleClearOptions();
      if (handleChange) handleChange([])
    }
  };

  //console.log('handleChange\n' + handleChange)
  //console.log('▼shops\n' + JSON.stringify(shops))
  return (
    <div className='wrapMultiSelect'>
      <MultiSelect
        items={items}
        label={label}
        getOptionLabel={getOptionLabel}
        selectedValues={shops}
        //selectedValues={handleStorageShops}
        selectAllLabel="全て"
        onToggleOption={handleToggleOption}
        onClearOptions={handleClearOptions}
        onSelectAll={handleSelectAll}
      />
    </div>
  );
};

export default MultiPulldown;
